import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { tasksApi } from '../../hrms/api/tasks';
import {
  markRead,
  markAllRead,
  selectNotifications,
} from '../../redux/slices/notifications';

export function useTaskNotificationActions() {
  const dispatch = useDispatch();

  const markOneRead = useCallback(
    async (notificationId: string) => {
      dispatch(markRead(notificationId)); // optimistic
      try {
        await tasksApi.markNotificationRead(notificationId);
      } catch {
        // Best-effort — the next page load will re-hydrate from the server.
        // No revert path because the slice doesn't preserve the prior value.
      }
    },
    [dispatch]
  );

  const markEveryRead = useCallback(async () => {
    dispatch(markAllRead()); // optimistic
    try {
      await tasksApi.markAllNotificationsRead();
    } catch {
      // Same as above.
    }
  }, [dispatch]);

  return { markOneRead, markEveryRead };
}

export const useTaskNotificationsList = () => useSelector(selectNotifications);
